import { FormEvent } from 'react'

import ArrowButton from '@/components/arrowButton'
import Input from '@/components/formFields/Input'
import Select from '@/components/formFields/Select'
import TextArea from '@/components/formFields/TextArea'
import { CONTACT_FORM } from '@/constants/contactUs'
import useContactUsForm from '@/hooks/useContactUsForm'
import styles from '@/styles/ContactForm.module.css'

const enquiryTypeOptions = [
  { label: CONTACT_FORM.ENTER_ENQUIRY_TYPE_PLACEHOLDER },
  { label: CONTACT_FORM.FARMER, value: CONTACT_FORM.FARMER },
  {
    label: CONTACT_FORM.DEHAAT_BUSINESS_PARTNER,
    value: CONTACT_FORM.DEHAAT_BUSINESS_PARTNER,
  },
  {
    label: CONTACT_FORM.INSTITUTIONAL_BUYER,
    value: CONTACT_FORM.INSTITUTIONAL_BUYER,
  },
  {
    label: CONTACT_FORM.AGRI_INPUT_SUPPLIER,
    value: CONTACT_FORM.AGRI_INPUT_SUPPLIER,
  },
]

const ContactForm = () => {
  const { errors, validateFormItem } = useContactUsForm()

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const isFormValid = Array.from(formData.entries()).every(([key, value]) =>
      validateFormItem(key, (value as string) || '')
    )
    if (!isFormValid) {
      event.preventDefault()
      return false
    }
  }

  return (
    <form
      onSubmit={onSubmit}
      action={process.env.NEXT_PUBLIC_CONTACT_US_FORM}
      acceptCharset="UTF-8"
      encType="multipart/form-data"
      method="POST"
      className={styles.contactForm}
    >
      <input
        type="hidden"
        name="zf_redirect_url"
        value="https://agrevolution.in/contact-us"
        className="hidden"
      />
      <div className="md:flex md:flex-row">
        <div className="md:flex-1 md:pl-[50px] pt-[30px]">
          <Input
            label={CONTACT_FORM.ENTER_NAME_LABEL}
            id="name"
            name="SingleLine"
            placeholder={CONTACT_FORM.ENTER_NAME_PLACEHOLDER}
            errorMessage={errors.name}
          />
          <Input
            label={CONTACT_FORM.PHONE_NUMBER_LABEL}
            id="phoneNumber"
            name="PhoneNumber_countrycode"
            placeholder={CONTACT_FORM.PHONE_NUMBER_PLACEHOLDER}
            type="number"
            errorMessage={errors.phoneNumber}
          />
          <TextArea
            id="message"
            label={CONTACT_FORM.ENTER_MESSAGE_LABEL}
            placeholder={CONTACT_FORM.ENTER_MESSAGE_PLACEHOLDER}
            errorMessage={errors.message}
            name="MultiLine"
          />
        </div>
        <div className="md:flex-1 md:pl-[50px] md:pt-[30px] md:pr-[30px] md:mt-0 -mt-2">
          <Input
            label={CONTACT_FORM.ENTER_EMAIL_LABEL}
            id="email"
            name="Email"
            placeholder={CONTACT_FORM.ENTER_EMAIL_PLACEHOLDER}
            type="email"
            errorMessage={errors.email}
          />
          <Select
            id="enquiryType"
            label={CONTACT_FORM.ENTER_ENQUIRY_TYPE_LABEL}
            options={enquiryTypeOptions}
            name="Dropdown"
          />
        </div>
      </div>
      <div
        className={`relative md:ml-[50px] mb-2 group w-32 ${styles.submitContainer} pb-8`}
      >
        <span
          className={`group-hover:bg-[#6fbc1d] group-hover:w-full absolute top-0 left-0 h-8 ${styles.slider}`}
        />
        <ArrowButton label="SUBMIT" btnType="submit" />
      </div>
    </form>
  )
}

export default ContactForm
